export default class EventEmitter {
    #eventHandlers = new Map();
    emit(event, ...args) {
        const eventHandlers = this.#eventHandlers.get(event);
        if (typeof eventHandlers === 'undefined') {
            return;
        }
        for (const handle of eventHandlers) {
            handle(...args);
        }
    }
    on(event, handler) {
        const eventHandlers = this.#eventHandlers.get(event);
        if (typeof eventHandlers === 'undefined') {
            this.#eventHandlers.set(event, [handler]);
        }
        else {
            eventHandlers.push(handler);
        }
    }
}
//# sourceMappingURL=event-emitter.js.map